var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHotmartLogoWhite = function SvgHotmartLogoWhite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hotmart-logo-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.256 26.598c-3.151-.025-5.685-2.525-5.659-5.584.026-3.059 2.602-5.518 5.753-5.493 3.152.025 5.686 2.526 5.66 5.584-.026 3.059-2.602 5.518-5.754 5.493Zm12.348-5.547c.155-2.941-.884-7.756-3.427-11.691-.068-.102-.183-.062-.158.046.17.6.21 1.684-.772 1.62-1.741-.114.06-3.73-3.763-6.238-.077-.05-.168.017-.126.097.262.483.418 1.992-.188 2.506-.486.412-1.378.301-2.236-1.057-1.43-2.264-.887-4.684.085-6.195.073-.113-.027-.158-.11-.131-5.26 1.684-6.31 7.7-7.43 9.895-.187.367-.35.56-.671.539-.958-.062-.268-2.046.064-2.736.046-.098-.069-.151-.13-.089C3.032 10.364.581 15.04.115 19.386c.015-.103-.043.359-.072.697v.001a14.718 14.718 0 0 0-.044.877C-.055 27.556 5.408 32.945 12.202 33c6.795.054 12.348-5.248 12.404-11.842l-.002-.107Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hotmart-logo-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24.619v33H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHotmartLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fb15a0d8c6e1713ad53c7351acbbc508.svg";